import { Axios } from "../../../lib/axios";

const openSearchRoute = "/openSearch";
const getTrendingKeywords = (queryParams) => {
  return Axios.get(`${openSearchRoute}/trends?${queryParams}`);
};

const getRecentlyViewed = () => {
  return Axios.get(`${openSearchRoute}/recently-viewed`);
};

const getSearchResults = (body) => {
  return Axios.post(`${openSearchRoute}/results`, body);
};

const checkResourceAccess = (body) => {
  return Axios.post(`${openSearchRoute}/access`, body);
};

const saveRecentlyViewedData = (body) => {
  return Axios.post(`${openSearchRoute}/recently-viewed`, body);
};

const fetchSearchSuggestions = (body) => {
  return Axios.post(`${openSearchRoute}/suggestions`, body);
};
const fetchSearchHistory = (body) => {
  return Axios.post(`${openSearchRoute}/history`, body);
};

export const OpenSearchService = {
  getTrendingKeywords,
  getRecentlyViewed,
  getSearchResults,
  checkResourceAccess,
  saveRecentlyViewedData,
  fetchSearchSuggestions,
  fetchSearchHistory,
};
